import Moment from 'moment'
import { validCnpj as validCnpjHelper, sanitizeCnpj } from '@/helpers/cnpj'

export const validCpf = {
  getMessage(field, args) {
    return 'teste'
  },
  validate(value, args) {
    return validateCpf(value)
  }
}

export const validCnpj = {
  getMessage(field, args) {
    return 'teste'
  },
  validate(value, args) {
    return validateCnpj(value)
  }
}

export const validCpfCnpj = {
  getMessage(field, args) {
    return 'teste'
  },
  validate(value, args) {
    return validateCpfCnpj(value)
  }
}

export const idadeMinima = (value, [idadeMinima]) => {
  try {
    const age = Moment().diff(Moment(value, 'DD/MM/YYYY'), 'years')
    return Boolean(age >= idadeMinima)
  } catch {
    return false
  }
}

export const cidadeValida = value => {
  if (typeof value === 'object') return !!value.Nome
  return !!Object.keys(value).length
}

const isCellPhone = function (phone) {
  if (Array.from(phone.substr(3)).reduce((acc, item) => acc.add(item), new Set()).size === 1) return false
  return true
}

export const telefoneValido = value => {
  try {
    const hasCountryPrefix = value.startsWith('+55')
    const cleanValue = value.replace(/\D/g, '')
    if (hasCountryPrefix) {
      return cleanValue.length >= 12 && cleanValue.length <= 13 && isCellPhone(cleanValue)
    } else {
      return cleanValue.length >= 11 && cleanValue.length <= 14 && isCellPhone(cleanValue)
    }
  } catch {
    return false
  }
}

export const idadeMaxima = (value, [idadeMaxima]) => {
  try {
    const age = Moment().diff(Moment(value, 'DD/MM/YYYY'), 'years')
    return Boolean(age <= idadeMaxima)
  } catch {
    return false
  }
}

export const dataValida = value => {
  try {
    const date = Moment(value, 'DD/MM/YYYY', true)
    return date.isValid()
  } catch {
    return false
  }
}

const validateCpf = cpf => {
  if (cpf === null || cpf === undefined || cpf === '') return true
  cpf = cpf.replace(/[^\d]+/g, '')
  // Elimina CPFs invalidos conhecidos
  if (
    cpf.length !== 11 ||
    cpf === '00000000000' ||
    cpf === '11111111111' ||
    cpf === '22222222222' ||
    cpf === '33333333333' ||
    cpf === '44444444444' ||
    cpf === '55555555555' ||
    cpf === '66666666666' ||
    cpf === '77777777777' ||
    cpf === '88888888888' ||
    cpf === '99999999999'
  ) {
    return false
  }

  // Valida 1o digito
  let add = 0
  for (let i = 0; i < 9; i++) {
    add += parseInt(cpf.charAt(i)) * (10 - i)
  }
  let rev = 11 - (add % 11)
  if (rev === 10 || rev === 11) {
    rev = 0
  }
  if (rev !== parseInt(cpf.charAt(9))) {
    return false
  }

  // Valida 2o digito
  add = 0
  for (let i = 0; i < 10; i++) {
    add += parseInt(cpf.charAt(i)) * (11 - i)
  }
  rev = 11 - (add % 11)
  if (rev === 10 || rev === 11) {
    rev = 0
  }
  if (rev !== parseInt(cpf.charAt(10))) {
    return false
  }
  return true
}

const validateCnpj = validCnpjHelper

const HAS_LETTER = /[A-Z]/

const validateCpfCnpj = value => {
  if (value === null || value === undefined || value === '') return true
  const sanitized = sanitizeCnpj(value)
  if (HAS_LETTER.test(sanitized) || sanitized.length > 11) return validateCnpj(sanitized)
  if (sanitized.length === 11) return validateCpf(sanitized)
  return false
}

export { validateCpf, validateCnpj, validateCpfCnpj }
